<template>
  <img
    :src="LoyaltyIconSvgTol"
    alt="loyalty-bloom-top-of-the-list-small.svg"
  />
</template>

<script setup>
import LoyaltyIconSvgTol from '@core/csg/src/assets/images/bcom/compressed/loyalty-bloom-top-of-the-list-small.svg';
</script>
